import Column from "@amzn/meridian/column";
import React, {useContext} from "react";
import { MobileDisplay } from "../../commons/MobileDisplay";
import Row from "@amzn/meridian/row";
import Select, { SelectOption } from "@amzn/meridian/select";
import { DwellFilterContext } from "../../commons/context/DwellFilterContext";
import { useDeviceLayout } from "../../commons/context/DeviceLayoutContext";
import ExportCSV from "../exportCsv/ExportCSV";
import { getDataInCSVFormat } from "../../util/ExportUtil";
import { ViewDataContext } from "../../commons/context/view/ViewDataContext";
import Tag from "@amzn/meridian/tag";
import Link from "@amzn/meridian/link";
import { injectIntl } from "react-intl";
import RefreshTimer from "../../commons/RefreshTimer";
import { FeatureConfigContext } from "../../commons/context/FeatureConfigContext";
import { chainWalk } from "../../commons/CommonUtils";
import { DWELL_FILTER_ACTIONS, FEATURES, FIVE_AND_THREE_HOUR, NO_FILTER_TAG_LIST } from "../../commons/constants/CommonConstants";

// This is used to show the filter view for new dwell detailed view

const DwellDetailedViewFilter = (props) => {
    
    const {viewModelFilter, filterDispatcher} = useContext(DwellFilterContext)
    const {spacingInset_shorthand2} = useDeviceLayout()
    const {viewModel} = useContext(ViewDataContext);
    const {configViewModel} = useContext(FeatureConfigContext);
    const selectedTabForPackages = props.selectedTabForPackages;
    const isFilterSet = () => {
        let result = false;
        Object.entries(viewModelFilter).forEach(entry => {
            const key = entry[0];
            const values = entry[1];
            result = result || (Array.isArray(values) && values.length && key !== 'data');
        });
        return result;
    }
    const clearAllFilters = () => {
        filterDispatcher({type: DWELL_FILTER_ACTIONS.REMOVE_ALL_FILTER});
    }
    const showPackageTypeColumnEnabled = chainWalk(() => configViewModel.featureStatus[FEATURES.IS_PACKAGE_TYPE_COLUMN_DWELL_ENABLED], false);
    return (
        <Column spacingInset={spacingInset_shorthand2} spacing={"none"}>
            <MobileDisplay visibility={false}>
                <Row width="100%" spacingInset="none" alignmentHorizontal={"right"}>
                    <ExportCSV selectedTabForPackages={selectedTabForPackages} isLink={true} csvData={getDataInCSVFormat(viewModel.packageResultList)} filePrefix={"DWELL"} />
                </Row>
            </MobileDisplay>
            {
                (selectedTabForPackages === FIVE_AND_THREE_HOUR || showPackageTypeColumnEnabled) ?
                <React.Fragment>
                <Column width="100%" spacing={"none"}>
                    <Row width="100%" wrap={"down"} spacingInset="medium small" spacing="small" backgroundColor="secondary">
                        
                        {selectedTabForPackages === FIVE_AND_THREE_HOUR ? 
                            <Select
                                onChange={(data) => {
                                    filterDispatcher({type: DWELL_FILTER_ACTIONS.SELECT_PACKAGE_SCHEDULED_DELIVERY_WINDOW, packageScheduledDeliveryWindow: data});
                                }}
                                value={viewModelFilter.packageScheduledDeliveryWindow}
                                size="small"
                                placeholder={props.intl.formatMessage({
                                    id: "dwell.filter.schedule.delivery.window", 
                                    defaultMessage: "Scheduled Delivery Window"})}
                                width={"230px"}>
                                {[...viewModelFilter.data.packageScheduledDeliveryWindow].sort().map(pckDeliveryWindow => (
                                    <SelectOption key={pckDeliveryWindow} label={pckDeliveryWindow} value={pckDeliveryWindow} />
                                ))}
                            </Select>
                        : null}
                        
                        {showPackageTypeColumnEnabled ? 
                            <Select
                                onChange={(data) => filterDispatcher({type: DWELL_FILTER_ACTIONS.SELECT_PACKAGE_TYPE, packageType: data})}
                                value={viewModelFilter.packageType}
                                size="small"
                                placeholder={props.intl.formatMessage({
                                    id: "dwell.filter.package.type",
                                    defaultMessage: "Type of package"
                                })}
                                width={"155px"}>
                                {[...viewModelFilter.data.packageType].sort().map(pckType => (
                                    <SelectOption key={pckType} label={pckType} value={pckType} />
                                ))}
                            </Select>
                        : null }
                    </Row>
                </Column>
                <Row width="100%" spacingInset="small none none none">
                    <Row spacing={"small"}>
                        {Object.entries(viewModelFilter).map(entry => {
                            const key = entry[0]
                            const values = entry[1]
                            return (
                                (Array.isArray(values) && !NO_FILTER_TAG_LIST.includes(key)) ? values.map(value => {
                                    return <Tag key={value} type="theme"
                                        onClose={() => filterDispatcher({
                                            type: DWELL_FILTER_ACTIONS.REMOVE_FILTER,
                                            data: {key, value}
                                        })}>{value}</Tag>
                                }) : null
                            )
                        })}
                        {isFilterSet() ? <Link onClick={clearAllFilters} type="secondary">Clear all</Link> : null}
                    </Row>
                </Row>
                </React.Fragment>
            : null }

            <Row spacingInset="small none">
                <RefreshTimer deps={[viewModel.lastUpdated]} lastUpdated={viewModel.lastUpdated} />
            </Row>
        </Column>
    )
}

export default injectIntl(DwellDetailedViewFilter)


// WEBPACK FOOTER //
// ./src/components/dwellRush/DwellDetailedViewFilter.js